import React from 'react';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

import { Header } from '../Header';
import './reset.scss';

// @ts-ignore
import * as styles from './Layout.module.scss';

interface Link {
  title: string;
  to: string;
}

interface Props {
  children: any;
  links?: Link[];
  basePage?: string;
  title: string;
  noAside?: boolean;
}
const Layout = ({ children, links, basePage, title, noAside }: Props) => {
  interface NavigationLinkProps {
    title: string;
    to: string;
  }

  const NavigationLink = ({ title, to }: NavigationLinkProps) => {
    return (
      <AnchorLink to={to} title={title} className={styles.NavigationItem}>
        <li>{title}</li>
      </AnchorLink>
    );
  };
  const menuMarkup = links && (
    <aside className={styles.Aside}>
      <ul className={styles.Navigation}>
        {links.map(link => (
          <NavigationLink title={link.title} to={link.to} key={link.title} />
        ))}
      </ul>
    </aside>
  );

  const mainStyles = noAside ? styles.MainWithNoAside : styles.Main;
  return (
    <>
      <div className={mainStyles}>
        <div className={styles.Header}>
          <Header siteTitle={`COVID-19 data visualization for ${title}`} />
        </div>
        <div className={styles.SiteMenu}>
          <AnchorLink to="/" className={styles.SiteMenuItem}>
            Canada
          </AnchorLink>
          <AnchorLink to="/quebec" className={styles.SiteMenuItem}>
            Quebec
          </AnchorLink>
          <AnchorLink to="/about" className={styles.SiteMenuItem}>
            About
          </AnchorLink>
        </div>
        {menuMarkup}
        <div className={styles.ContentWrapper}>{children}</div>

        <footer className={styles.Footer}>
          <div>
            <p>Website built on Gatsby by Jeremy Cobb</p>
          </div>
        </footer>
      </div>
    </>
  );
};

export { Layout };
